<template>
  <tr class="el-table__row block">
    <td class="block">
      <div class="cell" :title="value">
        <slot>
          {{ value }}
        </slot>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'ValueTableRow',

  props: {
    value: {
      required: true
    }
  }
}
</script>

<style scoped>
.block {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/common/components/table/ValueTableRow.vue